import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { useSimpleToggle } from 'hooks';
import React, { FC } from 'react';

import { FilterDropdownButton } from 'components/FilterDropdown/Button';
import { FilterOpen } from 'components/FilterDropdown/FilterOpen';
import { FilterDropdownProps } from 'components/FilterDropdown/index';
import { Filterable, mapFilterable } from 'components/FilterDropdown/util';
import { useDebounce } from 'hooks/useDebounce';

import { useOpeningOwners } from './hooks/useOpeningOwners';

export const FilterOpeningOwnerDropdown: FC<FilterDropdownProps<Filterable>> = ({
  selected,
  setSelected,
  showTitle,
  userId,
  error,
}) => {
  const { off, showContent: open, toggle: openUp } = useSimpleToggle();

  const { owners, setQuery } = useOpeningOwners(userId);
  const debounceSetQuery = useDebounce(setQuery, 500);

  const name = 'openingOwner';

  const options = mapFilterable(owners, {
    name,
    titleAttr: 'title',
    idAttr: 'id',
  });

  const selectedWithNames = selected.map(
    item => options.find(owner => owner.id === item.id) ?? item,
  );

  return (
    <ClickAwayListener onClickAway={off}>
      <div>
        <FilterDropdownButton
          name={name}
          open={open}
          openUp={openUp}
          count={selectedWithNames.length}
          clearFilter={() => setSelected([])}
          titles={selectedWithNames.map(item => item.title)}
          showTitle={showTitle}
          setSelected={setSelected}
          selected={selectedWithNames}
          error={error}
        />
        {open && (
          <FilterOpen
            name={name}
            selected={selectedWithNames}
            setSelected={setSelected}
            options={options}
            setQuery={debounceSetQuery}
          />
        )}
      </div>
    </ClickAwayListener>
  );
};
